
import { Component, Vue } from 'vue-property-decorator'
import LinkBase from '@/components/atoms/LinkBase.vue'
import ReconfigureMailMessage from '@/components/templates/ReconfigureMailMessage.vue'

/**
 * メールアドレス更新完了ページ
 */
@Component({
  components: {
    LinkBase,
    ReconfigureMailMessage,
  },
})
export default class ReconfigureMailComplete extends Vue {}
